import React, { Component } from 'react';

import { Chart } from 'react-google-charts';
import Wrapper from '../../../../hoc/Wrapper/Wrapper';
import DropDown from '../../DropDown/DropDown';

import classes from './LineChart.module.css';
import { IsObjectEmpty, IsListEmpty } from '../../../../utilities/CommonMethods';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';

class LineChart extends Component {

    state = {
        propData: {},
        activeDropDownItem: 0,
        dropDownOpen: false,
        oldCourseTitle: '',
        currentCourseTitle: ''
    }

    render() {
        return (
            <Wrapper>
                {
                    !IsObjectEmpty(this.props.chartData) && this.props.chartData.length !== 1
                        ? <div className={classes.LineChartContainer}>
                            {this.props.showLoader
                                ? <div className={classes.LoaderContainer}> <ShowLoader isLoading={this.props.showLoader} forLineChart={true} transparentBg={true} /></div>
                                : <Chart
                                    width={'100%'}
                                    height={'500px'}
                                    chartType="LineChart"
                                    // loader={<ShowLoader isLoading={true} forLineChart={true} />}
                                    data={this.props.chartData}
                                    options={{
                                        // title: this.props.options.title,
                                        chartArea: { width: '70%', height: '70%' },
                                        hAxis: {
                                            titleTextStyle: {
                                                color: '#555',
                                                italic: false,
                                                fontSize: 16,
                                                bold: true,
                                                fontName: 'Raleway',
                                                margin: 20
                                            },
                                            title: this.props.options.hTitle,
                                            minValue: 0,
                                        },
                                        vAxis: {
                                            titleTextStyle: {
                                                color: '#555',
                                                italic: false,
                                                fontSize: 16,
                                                bold: true,
                                                fontName: 'Raleway',
                                                amrgin: 20
                                            },
                                            viewWindowMode: 'explicit',
                                            viewWindow: {
                                                max: 100,
                                                min: 0
                                            },
                                            format: '#',
                                            title: this.props.options.vTitle,
                                        },
                                        curveType: 'function',
                                        legend: { position: 'bottom' },
                                        colors: ['#08A66C', 'green'],
                                        pointSize: 5,
                                    }}
                                />
                            }
                        </div>
                        : <div className={classes.LoaderContainer}> <ShowLoader isLoading={this.props.showLoader} forLineChart={true} transparentBg={true} /></div>
                }

            </Wrapper>
        );
    }
}

export default LineChart;